
      <!--  VIEW HEADER  -->

      <div *ngIf="uiLayoutConfig?.hasViewHeader !== false"
           class="view-header"
           [class.top-nav]="uiApp.navPosition === 'top'"
           [class.consumer]="uiApp.audience === 'consumer'"
           [class.has-key-functions]="hasKeyFunctions"
           [class.has-module-nav]="uiAppModule?.hasModuleNav !== false">

          <!--  TITLE  -->

          <div class="title-container">
              <h2>{{title}}<span *ngFor="let suffix of suffixes" class="acc-hl-col">{{ suffix }}</span></h2>
          </div>

          <!--  END TITLE  -->

          <!--  KEY FUNCTIONS  -->

          <div *ngIf="hasKeyFunctions" class="key-functions-container">
              <ng-content></ng-content>
          </div>

          <!--  END KEY FUNCTIONS  -->

      </div>

      <!--  END VIEW HEADER  -->
    